import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

function PasswordField({ label, value, onChange, testid }) {
  const [shown, setShown] = useState(false);
  return (
    <>
      <label className="block text-sm text-silver mb-1" htmlFor={testid}>{label}</label>
      <div className="relative mb-4">
        <input id={testid} data-testid={testid} className="input pr-10" type={shown ? "text" : "password"}
          autoComplete="new-password" value={value} onChange={(e) => onChange(e.target.value)} />
        <button type="button" onClick={() => setShown(s => !s)} className="absolute right-2 top-1/2 -translate-y-1/2 text-silver"
          aria-label={`Show or hide ${label.toLowerCase()}`} data-testid={`${testid}-toggle`}>
          {shown ? <EyeOff size={18}/> : <Eye size={18}/>}
        </button>
      </div>
    </>
  );
}

export default function ChangePasswordPage() {
  const { refresh, user } = useAuth();
  const nav = useNavigate();
  const [cur, setCur] = useState(""); const [n1, setN1] = useState(""); const [n2, setN2] = useState("");
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault(); setErr("");
    if (n1 !== n2) { setErr("New passwords do not match"); return; }
    if (n1.length < 6) { setErr("New password must be at least 6 characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/password/change", { current_password: cur, new_password: n1, confirm_password: n2 });
      const me = await refresh();
      let dest = "/";
      if ((me?.role || user?.role) === "Worker") {
        const { data } = await api.get("/me/onboarding");
        dest = data.complete ? "/my/timesheets" : "/onboarding";
      }
      nav(dest, { replace: true });
    } catch (e) {
      setErr(e?.response?.data?.detail || "Failed to change password");
    } finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-black p-4">
      <form onSubmit={submit} className="w-full max-w-md card">
        <h1 className="text-xl text-white mb-6 text-center">Change your password</h1>
        <PasswordField label="Current password" value={cur} onChange={setCur} testid="cp-current" />
        <PasswordField label="New password" value={n1} onChange={setN1} testid="cp-new" />
        <PasswordField label="Confirm new password" value={n2} onChange={setN2} testid="cp-confirm" />
        {err && <div className="text-red-500 text-sm mb-3" data-testid="cp-error">{err}</div>}
        <button data-testid="cp-submit" disabled={busy} className="btn-silver w-full">
          {busy ? "Saving…" : "Change password"}
        </button>
      </form>
    </div>
  );
}
